import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

import { MaterialLinkModel } from '../../business/material-link-model';

@Component({
    selector: 'ecm-mat-accordions',
    templateUrl: 'material-accordions.html',
    styleUrls: ['material-accordions.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgbAccordionModule],
})
export class MaterialAccordionsComponent {
    public readonly title = input<string>(undefined);
    public readonly items = input.required<
        {
            title: string;
            description: string | string[];
            link?: MaterialLinkModel;
        }[]
    >();
    public readonly e2e = input('e2e-mat-seo-accordions');
    public readonly clickAccordionLink = output<any>();
    public readonly customStyle = input<string>(undefined);
    public readonly ariaLabel = input<string>(undefined);

    // Force description to be an array
    public readonly normalizedItems = computed(() =>
        this.items()?.map((item) => {
            const description = Array.isArray(item.description) ? item.description : [item.description];
            return { ...item, description };
        }),
    );
}
